import React from 'react';
import { t } from '../lib/i18n';
import { Badge } from './ui/badge';

export const RentPaymentStatus = ({ info }) => {
  if (info?.overdueDays > 0) return <Badge className="bg-rose-100 text-rose-800 border-rose-200">{t(info.overdueDays === 1 ? '1 day overdue' : '{{days}} days overdue', { days: info.overdueDays })}</Badge>;
  if (info?.shop?.feeStatus === 'due_soon') return <Badge className="bg-amber-100 text-amber-800 border-amber-200">Due in {info.shop.daysLeft}d</Badge>;
  return <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200">Up to date</Badge>;
};